import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Estoy cerrando más que nunca con XLEADS. La calidad de los leads es increíble y el soporte siempre está ahí cuando lo necesito.',
    name: 'Roxy Villazana',
    role: 'Agente de Seguros de Vida',
    image: 'https://cdn.magicpatterns.com/uploads/6STPz9hmLnenwZXskvzYJp/WhatsApp_Image_2026-02-26_at_20.34.37.jpg',
    imagePosition: 'top'
  }, {
    quote: 'Este año los estamos proyectado a un millón gracias a Xleads. Los leads son frescos y listos para cerrar.',
    name: 'Yasser Fermin',
    role: 'Agente de Seguros de Vida',
    image: 'https://cdn.magicpatterns.com/uploads/uMt6Mx2gun5Aijor9gNKGz/DSC06946.jpg',
    imagePosition: '50% 25%'
  }, {
    quote: 'Trabajar con los leads correctos lo cambió todo. Desde que empecé con Xleads mis resultados se transformaron por completo.',
    name: 'Joselyn Guzman',
    role: 'Agente de Seguros de Vida',
    image: 'https://cdn.magicpatterns.com/uploads/pZekoJSF2pMWrCqvHd34nf/WhatsApp_Image_2026-02-26_at_20.34.29.jpg',
    imagePosition: 'top'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="testimonios" className="bg-brand-charcoal py-12 md:py-16 px-4" data-id="element-100">
      <div className="max-w-7xl mx-auto" data-id="element-101">
        <div className="text-center mb-10" data-id="element-102">
          <span className="block text-sm font-bold tracking-widest text-brand-orange uppercase mb-4" data-id="element-103">
            Testimonios
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white text-balance" data-id="element-104">
            Lo Que Dicen Nuestros Agentes
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-105">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={cardVariants} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 flex flex-col" data-id="element-106">
              <div className="flex gap-1 mb-4" data-id="element-107">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-orange text-brand-orange" data-id="element-108" />)}
              </div>

              <blockquote className="text-lg text-white italic mb-5 flex-grow" data-id="element-109">
                "{testimonial.quote}"
              </blockquote>

              <div className="w-full h-px bg-white/10 mb-4" data-id="element-110"></div>

              <div className="flex items-center gap-3" data-id="element-111">
                {testimonial.image ? <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover ring-2 ring-brand-orange/30" loading="lazy" decoding="async" style={{
              objectPosition: testimonial.imagePosition || 'top'
            }} data-id="element-112" /> : <div className="w-12 h-12 rounded-full bg-brand-orange/20 flex items-center justify-center text-brand-orange font-bold text-lg ring-2 ring-brand-orange/30" data-id="element-113">
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </div>}
                <div data-id="element-114">
                  <div className="font-bold text-white" data-id="element-115">{testimonial.name}</div>
                  <div className="text-sm text-gray-400 mt-0.5" data-id="element-116">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}